import { render, staticRenderFns } from "./ProjectRole.vue?vue&type=template&id=5ea84792"
import script from "./ProjectRole.vue?vue&type=script&lang=js"
export * from "./ProjectRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports